import * as React from "react";
import { IconPanel, Statistics, useTheme } from "@tiny/components";
import { formatNumber } from "@tiny/components/src/utils/formatUtils";
import UploadOutline from "@tiny/icons/generated/UploadOutline";
import useBreakpoints from "@tiny/components/src/hooks/useBreakpoints";

function TabStats({ totalCount }: { totalCount: number | undefined }) {
  const { mdUp } = useBreakpoints();
  const theme = useTheme();

  return (
    <IconPanel
      icon={<UploadOutline />}
      color={theme.palette.blue.dark}
      hasBorderRadius={mdUp}
    >
      <Statistics
        valueVariant="h2"
        value={formatNumber(totalCount ?? 0)}
        title="AI recommended pre-built segments"
        info="Our most popular segments pre-built for you"
      />
    </IconPanel>
  );
}

export default TabStats;
